module.exports = __webpack_public_path__ + "img/visual_collaboration.d193de92.svg";